import { useEffect, useState } from 'react';
import BasicTable from '../../../components/table';
import { api } from '../../../services/axios';
import { AddModal } from './styles';

import AddIcon from '@mui/icons-material/Add';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Autocomplete, Button, CircularProgress, Divider, InputAdornment, Stack, Switch, TextField } from '@mui/material';
import { encode } from 'base-64';
import Modal from "react-modal";
import { ModalAlert } from '../../../components/modal';
import { ModalAlertDiv } from '../../../components/modal/style';
import { TableBar } from '../../../components/table/styles';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import SelectMui from '../../../components/select';
import { DateRange, DateRangePicker } from 'react-date-range';
import { newDateFormat } from '../../../components/date';
import PercentIcon from '@mui/icons-material/Percent';
import ModalDelete from '../../../components/modal/modalDelete';


const Campaigns = () => {
  const url = "core/ajax/campaigns"

  const headers = [
    { label: 'Id', value: 'IdCamp' },
    { label: 'Name', value: 'Campaign' },
    { label: 'TSource', value: 'Token' },
    { label: 'CreateDate', value: 'CreateDate' },
    { label: 'Engine', value: 'engineActive' },
    { label: 'Active', value: 'Active' },
    { label: 'Actions', value: 'Actions' },
  ]

  const [rows, setRows] = useState({ default: [], filter: [] })

  const [showModal, setShowModal] = useState(false)

  const [isValidate, setIsValidate] = useState(false)
  const [form, setForm] = useState(defaultForm);
  const [alert, setAlert] = useState({ msg: '', status: undefined });
  const [showAlert, setShowAlert] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [id, setId] = useState();
  const [isCreate, setIsCreate] = useState(true);
  const [tags, setTags] = useState([]);

  const [formEngine, setFormEngine] = useState(defaultEngine);
  const [showModalEngine, setShowModalEngine] = useState(false);
  const [formWeight, setFormWeight] = useState({});

  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  useEffect(() => {
    listUpdate()
  }, [])

  const getFields = () => {
    api.post(url, {
      type: 'info',
      id: 0,
      authx: ''
    })
      .then(function (res) {
        setForm({
          ...form,
          channels: res.data.combo.channels.map((e) => { return { value: e.IdCampChannel, label: e.Channel } }),
          channelsValue: '',

          generators: res.data.combo.generators.map((e) => { return { value: e.IdCompany, label: e.Company } }),
          generatorsValue: '',

          pools: res.data.combo.pools,
          poolsValue: '',

          products: res.data.combo.products.map((e) => { return { value: e.IdCampProduct, label: e.Product } }),
          productsValue: '',

          types: res.data.combo.types.map((e) => { return { value: e.IdCampType, label: e.type } }),
          typesValue: '',
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const listUpdate = () => {
    api.post(url, {
      type: 'list',
      authx: ''
    })
      .then(function (res) {
        setRows({
          default: res.data.map((e) => {
            return {
              ...e,
              IdCamp: Number(e.IdCamp),
            }
          }), filter: res.data.map((e) => {
            return {
              ...e,
              IdCamp: Number(e.IdCamp),
            }
          })
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const createCampaign = () => {
    api.post(url, {
      type: 'insert',
      authx: '',
      combo: null,
      Type: form.typesValue,
      Generator: form.generatorsValue,
      Uri: form.url,
      Product: form.productsValue,
      Campaign: form.name,
      Description: form.description,
      Channel: JSON.stringify(tags.map(e => { return { IdCampChannel: e.value, Channel: e.label } })),

      StartDate: newDateFormat(range[0].startDate),
      EndDate: newDateFormat(range[0].endDate),
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const updateForm = (row) => {
    api.post(url, {
      type: 'info',
      id: row.IdCamp.toString(),
      authx: ''
    })
      .then(function (res) {
        const arr = res.data['0'].IdCampChannel.split(",");

        setForm({
          channels: res.data.combo.channels.map((e) => { return { value: e.IdCampChannel, label: e.Channel } }),
          channelsValue: res.data['0'].IdCampChannel,

          generators: res.data.combo.generators.map((e) => { return { value: e.IdCompany, label: e.Company } }),
          generatorsValue: res.data['0'].IdCompany,

          pools: res.data.combo.pools,
          poolsValue: [''],

          products: res.data.combo.products.map((e) => { return { value: e.IdCampProduct, label: e.Product } }),
          productsValue: res.data['0'].IdCampProduct,


          types: res.data.combo.types.map((e) => { return { value: e.IdCampType, label: e.type } }),
          typesValue: res.data['0'].IdCampType,

          name: res.data['0'].Campaign,
          url: res.data['0'].Uri,

          description: row.Description,


          limit: res.data['0'].Limit,
          bonus: res.data['0'].Bonus,
          priority: res.data['0'].Priority,
          calendar: res.data['0'].IdCompany,
        })

        setRange([
          {
            startDate: new Date(res.data['0'].StartDate),
            endDate: new Date(res.data['0'].EndDate),
            key: "selection",
          },
        ])

        setTags(arr.map((e) => {
          return {
            value: e, label: res.data.combo.channels?.find((el) => el.IdCampChannel === e).Channel
          }
        }))

      })
      .catch(function (error) {
        console.log(error);
      });
    setIsCreate(false)
    setShowModal(true)
    setId(row.IdCamp)
  }

  const confirmUpdateForm = () => {
    api.post(url, {
      type: 'update',
      authx: '',
      IdCamp: id,

      IdCampProduct: form.productsValue,
      Campaign: form.name,
      Description: form.description,
      IdCompany: form.generatorsValue,
      Uri: form.url,
      StartDate: newDateFormat(range[0].startDate),
      EndDate: newDateFormat(range[0].endDate),
      Channel: JSON.stringify(tags.map(e => { return e.value }).toString()),

      IdCampType: form.typesValue,

      IdPool: 1,
      CampaignIdExt: '',
      Tsource: '',
      Dnis: '',
      DnisInt: '',
    }).then(function (res) {
      setAlert(res.data)
      listUpdate()
    }).catch(function (error) {
      console.log(error);
    });

  }

  const onDelete = (id) => {
    setId(id)
    setShowDelete(!showDelete)
    setAlert({ status: "go" })
  }

  const confirmDelete = () => {
    api.post(url, {
      type: 'delete',
      IdCamp: Number(id),
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }

  const validation = () => {
    console.log(form);
    if (form.name === ''
      || form.typesValue === ''
      || form.generatorsValue === ''
      || form.url === ''
      || tags.length < 1
      || form.productsValue === '') {

      setIsValidate(true)

      return false
    } else {
      return true
    }
  }

  const validationEngine = () => {
    if (formEngine.Bonus === '' || formEngine.Calendar === ''
      || formEngine.EngDescription === '' || formEngine.Priority === ''
      || formEngine.Limit === '') {
      setIsValidate(true)
      return false
    } else {
      return true
    }
  }

  const handleActive = (id, active) => {
    api.post(url, {
      type: 'activeCampaign',
      IdCamp: Number(id),
      active: active,
      authx: ''
    })
      .then(function (res) {
        res.data.status === 'ko' && setShowAlert(true)
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setShowAlert(true)
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }


  const updateEngine = (id) => {
    const url = "core/ajax/engines"
    api.post(url, {
      type: 'info',
      id: id.toString(),
      authx: ''
    })
      .then(function (res) {
        setFormEngine({
          Active: res.data['0'].Active,
          Algorithm: res.data['0'].Algorithm,
          Bonus: res.data['0'].Bonus,
          Calendar: res.data['0'].Calendar,
          Campaign: res.data['0'].Campaign,
          EngDescription: res.data['0'].EngDescription,

          Limit: res.data['0'].Limit,
          Priority: res.data['0'].Priority,

          templateList: res.data.combo.templates,
          templateValue: res.data['0'].IdEngTemplate,

          engineType: res.data.combo.types.map((e) => { return { value: e.IdEngAlgorithm, label: e.Algorithm } }),
          engineTypeValue: res.data['0'].IdEngAlgorithm,

          transformers: res.data.combo.transformers,
          transformersValue: res.data?.engine['1'] ? res.data.engine['1']['0'].IdTransformer : '',

          calendarList: res.data.combo.calendars.map((e) => { return { value: e.IdEngineCalendar, label: e.Calendar } }),
          calendarValue: res.data['0'].IdEngineCalendar,

          IdCamp: res.data['0'].IdCamp,
          idEngDirect: res.data?.engine['1'] ? res.data.engine['1']['0'].IdEngDirect : '',
          IdCampEngine: res.data['0'].IdCampEngine
        })
        setFormWeight(res.data.engine['2'] ? res.data?.engine['2'] : {})
        setId(res.data['0'].IdCampEngine)
      })
      .catch(function (error) {
        console.log(error);
      });

    setShowModalEngine(true)
  }

  const confirmUpdateFormEngine = () => {
    const url = "core/ajax/campaigns"
    const newForm = Object.fromEntries(Object.entries(formWeight).filter(([_, v]) => v.Weight !== ''));
    const sumValues = Object.values(newForm).reduce((a, b) => a + Number(b.Weight), 0);

    if (formEngine.engineTypeValue === '1') {
      api.post(url, {
        data0: JSON.stringify({
          Active: formEngine.Active ? '1' : '0', // Não tem alteração
          IdEngAlgorithm: formEngine.engineTypeValue, // Id do engine type
          IdCamp: formEngine.IdCamp,
          EngDescription: formEngine.EngDescription, // Campo descrição
          Limit: formEngine.Limit,
          Bonus: formEngine.Bonus,
          Priority: formEngine.Priority,
          IdEngTemplate: formEngine.templateValue,
          IdEngineCalendar: formEngine.calendarValue, // 

          IdCampEngine: Number(id).toString(), // ID da engine
          type: "engineModify",
          authx: ''
        }),
        engine: JSON.stringify({
          "1": [
            {
              IdTransformer: formEngine.transformersValue,
              IdCampEngine: Number(id).toString(),
              IdEngDirect: formEngine.idEngDirect
            }]
        })
      }).then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
        .catch(function (error) {
          console.log(error);
        });

    } else if (formEngine.engineTypeValue === '2' && sumValues <= 100) {
      api.post(url, {
        data0: JSON.stringify({
          Algorithm: formEngine.Algorithm, // Label engine type
          Active: formEngine.Active ? '1' : '0', // Não tem alteração
          IdEngAlgorithm: formEngine.engineTypeValue, // Id do engine type
          IdCamp: formEngine.IdCamp,
          Campaign: formEngine.Campaign,
          IdEngineCalendar: formEngine.calendarValue, // 
          Calendar: formEngine.Calendar, // Campo Calendar
          campaignActive: formEngine.campaignActive, // Não tem alteração
          Priority: formEngine.Priority,
          Limit: formEngine.Limit,
          Bonus: formEngine.Bonus,
          EngDescription: formEngine.EngDescription, // Campo descrição
          IdEngTemplate: formEngine.templateValue,
          IdCampEngine: id.toString(), // ID da engine
          type: "engineModify",
          authx: ''
        }),
        engine: JSON.stringify({
          "2": newForm
        })
      })
        .then(function (res) {
          setAlert(res.data)
          listUpdate()
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setAlert({ msg: 'Sum of all Transformers must be in max 100', status: 'Error' })
    }
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxHeight: "90%",
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    }
  };


  const inputFilter = (e) => {
    const filter = rows.default.filter((row) => {
      return row.Campaign.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.IdCamp.toString().includes(e.target.value) ||
        row.Token?.includes(e.target.value) ||
        row.CreateDate.includes(e.target.value)
    });
    setRows({ ...rows, filter })
  }

  return (
    <TableBar>

      <h1>List Campaigns</h1>
      <div className='buttons'>

        <TextField
          label="Search"
          variant="outlined"
          size='small'
          onChange={inputFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />

        <Button startIcon={<AddIcon />} onClick={() => {
          setShowModal(!showModal)
          setIsCreate(true)
          getFields()
        }} variant="contained">Add</Button>
      </div>

      <BasicTable type={'campaigns'} headers={headers} rowsProps={rows.filter} updateForm={updateForm} onDelete={onDelete} handleActive={handleActive} updateEngine={updateEngine} />

      {/* Modal de Campaign */}
      <Modal
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false)
          setForm(defaultForm)
          setTags([])
          setRange([
            {
              startDate: new Date(),
              endDate: new Date(),
              key: "selection",
            },
          ])

          setIsValidate(false)
        }}
        style={customStyles}
        ariaHideApp={false}>
        <h1>Campaigns</h1>
        <Divider sx={{ m: '1.2rem 0' }} variant="middle" />
        <AddModal>
          <div className="fields">

            <SelectMui
              label="Type"
              width={'18rem'}
              size={'medium'}
              helperText={form.typesValue === '' && isValidate ? "Please select one." : ""}
              error={form.typesValue === '' && isValidate}
              values={form.types}
              state={form.typesValue}
              onChange={(e) => {
                setForm({ ...form, typesValue: e.target.value })
              }}
            />

            {(form.typesValue === "2" || form.typesValue === '3') &&
              <SelectMui
                label="Pool"
                width={'18rem'}
                size={'medium'}
                values={form.pools}
                state={form.poolsValue}
                onChange={(e) => {
                  setForm({ ...form, poolsValue: e.target.value })
                }}
              />}

            <SelectMui
              label="Generator"
              width={'18rem'}
              size={'medium'}
              helperText={form.generatorsValue === '' && isValidate ? "Please select one." : ""}
              error={form.generatorsValue === '' && isValidate}
              values={form.generators}
              state={form.generatorsValue}
              onChange={(e) => {
                setForm({ ...form, generatorsValue: e.target.value })
              }}
            />

            <SelectMui
              label="Product"
              width={'18rem'}
              size={'medium'}
              helperText={form.productsValue === '' && isValidate ? "Please select one. " : ""}
              error={form.productsValue === '' && isValidate}
              values={form.products}
              state={form.productsValue}
              onChange={(e) => {
                setForm({ ...form, productsValue: e.target.value })
              }}
            />

            <TextField label="Url" variant="outlined"
              sx={{ width: '18rem' }}
              helperText={form.url === '' && isValidate ? "Incorrect entry." : ""}
              error={form.url === '' && isValidate}
              value={form.url}
              onChange={(e) => {
                setForm({
                  ...form,
                  url: e.target.value
                })
              }} />

            <TextField label="Name" variant="outlined"
              helperText={form.name === '' && isValidate ? "Incorrect entry." : ""}
              error={form.name === '' && isValidate}
              sx={{ width: '18rem' }}
              value={form.name}
              onChange={(e) => {
                setForm({
                  ...form,
                  name: e.target.value
                })
              }} />

            <TextField label="Description" variant="outlined"
              sx={{ width: '18rem' }}
              value={form.description}
              multiline
              onChange={(e) => {
                setForm({
                  ...form,
                  description: e.target.value
                })
              }} />

            <Autocomplete
              multiple
              style={{ width: '18rem' }}
              limitTags={2}
              options={form.channels}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, value) => {
                return option.value === value.value
              }}
              value={tags}
              onChange={(e, val) => {
                val !== null && setTags(val)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={tags.length < 1 && isValidate}
                  label="Channel"
                  placeholder="Channel"
                  helperText={tags.length < 1 && isValidate ? 'Please choose at least one.' : '* Press enter to add'}
                />
              )}
            />
          </div>
          <Divider sx={{ m: '1.2rem 0' }} variant="middle" />
          <div className="date-range">

            <h2>Date range</h2>

            <DateRange
              className='date'
              editableDateInputs={true}
              dateDisplayFormat='yyyy-MM-dd'
              onChange={item => setRange([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={range}
            />
          </div>
          <Button sx={{ marginTop: '1rem' }} fullWidth onClick={() => {
            // setError({
            //   name: form.name === '' ? true : false,
            //   address: form.address === '' ? true : false,
            //   city: form.city === '' ? true : false,
            //   country: form.country === '' ? true : false,
            //   language: form.language === '' ? true : false,
            //   inbEndPoint: (form.inbEndPoint === '' && form.inbTransfer !== 'NAN') ? true :
            //     ((form.inbTransfer === 'SIP') ||
            //       (form.inbTransfer === 'PHO' && (!isNaN(form.inbEndPoint) || form.inbEndPoint === '') && form.inbEndPoint.length > 10)) ? false : true
            // })
            if (validation()) {
              isCreate ? createCampaign() : confirmUpdateForm()
              setShowAlert(!showAlert)
            } else {
              console.log(validation());
            }
          }} variant="contained">{isCreate ? 'Create' : 'Update'}</Button>

        </AddModal>
      </Modal>

      {/* Modal de Engines */}
      <Modal isOpen={showModalEngine}
        onRequestClose={() => {
          setShowModalEngine(false)
          setIsValidate(false)
          setFormEngine(defaultEngine)
        }}
        style={customStyles}
        ariaHideApp={false}>
        <AddModal>
          <Stack
            direction="row"
            spacing={2}
            sx={{ marginBottom: '1rem' }}
            justifyContent="space-between">
            <h1>Engine</h1>
            <Switch checked={formEngine.Active} onChange={(e) => { setFormEngine({ ...formEngine, Active: e.target.checked }) }} />
          </Stack>

          <Divider className='divider' variant="middle" />
          <Stack sx={{ gap: '.8rem' }}>

            <Autocomplete
              disabled={true}
              size='medium'
              options={formEngine.templateList}
              getOptionLabel={(option) => option.Template}
              value={formEngine.templateList.find(e => e.IdEngTemplate === formEngine.templateValue)}
              onChange={(e, value) => {
                setFormEngine({ ...formEngine, templateValue: value.IdEngTemplate })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Template"
                />
              )}
            />

            <SelectMui
              label="Engine Type"
              width={'max'}
              size={'medium'}
              values={formEngine.engineType}
              state={formEngine.engineTypeValue}
              onChange={(e, val) => {
                setFormEngine({ ...formEngine, engineTypeValue: e.target.value, Algorithm: val.props.children })
              }}

            />

            <TextField label="Description" variant="outlined"
              helperText={formEngine.EngDescription === '' && isValidate ? "Incorrect entry." : ""}
              error={formEngine.EngDescription === '' && isValidate}
              value={formEngine.EngDescription}
              onChange={(e) => {
                // e.target.value !== '' ? setError({ ...error, EngDescription: false }) : setError({ ...error, EngDescription: true })
                setFormEngine({
                  ...formEngine,
                  EngDescription: e.target.value
                })
              }} />

            <TextField label="Limit" variant="outlined"
              helperText={formEngine.Limit === '' && isValidate ? "Incorrect entry." : ""}
              error={formEngine.Limit === '' && isValidate}
              value={formEngine.Limit}
              onChange={(e) => {
                // e.target.value !== '' ? setError({ ...error, Limit: false }) : setError({ ...error, Limit: true })
                setFormEngine({
                  ...formEngine,
                  Limit: e.target.value
                })
              }} />

            <TextField label="Bonus" variant="outlined"
              helperText={formEngine.Bonus === '' && isValidate ? "Incorrect entry." : ""}
              error={formEngine.Bonus === '' && isValidate}
              value={formEngine.Bonus}
              onChange={(e) => {
                // e.target.value !== '' ? setError({ ...error, Bonus: false }) : setError({ ...error, Bonus: true })
                setFormEngine({
                  ...formEngine,
                  Bonus: e.target.value
                })
              }} />

            <TextField label="Priority" variant="outlined"
              helperText={formEngine.Priority === '' && isValidate ? "Incorrect entry." : ""}
              error={formEngine.Priority === '' && isValidate}
              value={formEngine.Priority}
              onChange={(e) => {
                // e.target.value !== '' ? setError({ ...error, Priority: false }) : setError({ ...error, Priority: true })
                setFormEngine({
                  ...formEngine,
                  Priority: e.target.value
                })
              }} />

            <SelectMui
              label="Calendar"
              width={'max'}
              size={'medium'}
              values={formEngine.calendarList}
              state={formEngine.calendarValue}
              onChange={(e, val) => {
                setFormEngine({ ...formEngine, calendarValue: e.target.value })
              }}

            />

            <h2>{formEngine.engineTypeValue === '1' ? 'Direct' : 'DISTRIBUTION BY WEIGHT'}</h2>
            {
              formEngine.engineTypeValue === '1' ?
                <Autocomplete
                  size='medium'
                  options={formEngine?.transformers}
                  getOptionLabel={(option) => option.Company}
                  onChange={(e, value) => {
                    setFormEngine({
                      ...formEngine,
                      transformersValue: value.IdCompany
                    })
                  }}
                  value={formEngine.transformers.find(e => e.IdCompany === formEngine.transformersValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Transformer"
                    />
                  )}
                /> : formEngine.transformers?.map((ele) => {
                  return <TextField label={ele.Company} variant="outlined"
                    helperText={formEngine.calendar ? "Incorrect entry." : ""}
                    key={ele.IdCompany}
                    value={formWeight[ele.IdCompany]?.Weight !== undefined ? formWeight[ele.IdCompany].Weight : ''}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <PercentIcon />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => {
                      (/^[1-9][0-9]?$|^100$/.test(e.target.value) || e.target.value === '') && setFormWeight({
                        ...formWeight,
                        [ele.IdCompany]: { Weight: e.target.value.replace(/\D/g, "") }
                      })
                    }} />
                })}
            <Button onClick={() => {
              if (validationEngine()) {
                confirmUpdateFormEngine()
                setShowAlert(!showAlert)
              } else {
                console.log(formEngine);
              }
            }} variant="contained">{'Update'}</Button>
          </Stack>
        </AddModal>
      </Modal>


      {/* Modal de Alerta */}
      <ModalAlert showModal={showAlert} onClose={() => {
        setShowAlert(!showAlert)
        setAlert({ msg: '', status: undefined })
      }} onClickOutside={false}>
        {alert.status === undefined ?
          <ModalAlertDiv>
            <CircularProgress />
            <h1> {showModal ? (isCreate ? 'Creating campaign' : 'Updating campaign') : 'Updating engine'}</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
          : alert.status === 'ok' ?
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>

              <Button onClick={() => {
                setShowAlert(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>
            :
            <ModalAlertDiv>
              <h2>Error code {alert.code}</h2>
              <h3>:&#40;	</h3>
              <p>{alert.msg}</p>
            </ModalAlertDiv>}
      </ModalAlert>

      {/* Modal de delete */}
      <ModalDelete type={'campaigns'} showDelete={showDelete} alert={alert} setShowDelete={setShowDelete} setAlert={setAlert} confirmDelete={confirmDelete} />
    </TableBar>
  );
}

export default Campaigns;


const defaultForm = {
  channels: [{ value: '', label: '' }],
  channelsValue: '',

  generators: [{ value: '', label: '' }],
  generatorsValue: '',

  pools: [{ value: '', label: '' }],
  poolsValue: '',

  products: [{ value: '', label: '' }],
  productsValue: '',

  types: [{ value: '', label: '' }],
  typesValue: '',

  url: '',
  description: '',
  name: ''
}

const defaultEngine = {
  templateList: [{ IdEngTemplate: '', Template: '' }],
  templateValue: '',
  engineType: [''],
  engineTypeValue: '',
  EngDescription: '',
  Limit: '',
  Bonus: '',
  Priority: '',
  Calendar: '',
  template: '',
  transformersValue: [],
  calendarList: [],
  calendarValue: ""
}